import {createTheme, PaletteOptions, Theme, ThemeOptions} from "@mui/material";
import {blue, grey} from "@mui/material/colors";

export function CreateThemeWithMode(mode: 'light' | 'dark'): Theme {

    let baseTheme: ThemeOptions = {
        direction: 'rtl',
        typography: {
            fontFamily: 'IranSans',
            fontSize: 11,
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        borderRadius: '12px',
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: '10px',
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    colorPrimary: {
                        backgroundColor: mode === 'light' ? 'rgba(255,255,255,0.8)' : 'rgba(25,25,30,0.8)',
                        backdropFilter: "blur(20px)",
                        boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
                        borderRadius: 0
                    }
                }
            },
            MuiMobileStepper: {
                styleOverrides: {
                    dot: {
                        backgroundColor: 'rgba(255,255,255,0.4)'
                    },
                    dotActive: {
                        backgroundColor: 'white'
                    },
                },
            },
            MuiCssBaseline: {
                styleOverrides: `
                @font-face {
                  font-family: 'IranSans';
                  font-style: normal;
                  font-display: swap;
                  font-weight: 400;
                  src: url(./fonts/IranSans.woff2) format('woff2');
                }
                @font-face {
                  font-family: 'Material Icons';
                  font-style: normal;
                  font-weight: 400;
                  src: url('./fonts/GoogleFonts.woff2') format('woff2');
                }`,
            },
        },
    }

    let lightThemePalette: PaletteOptions = {
        mode: 'light',
        primary: blue,
        secondary: {
            main: '#009e44',
        },
        background: {
            default: '#EEEEEE',
            paper: 'white',
        },
        text: {
            primary: grey[900],
            secondary: grey[700],
        }
    }

    let darkThemePalette: PaletteOptions = {
        mode: 'dark',
        primary: blue,
        secondary: {
            main: '#009e44',
        },
        background: {
            default: '#19191e',
            paper: '#202025',
        },
        text: {
            primary: grey[100],
            secondary: grey[300],
        }
    }

    let options = {
        ...baseTheme,
        palette: mode === 'light' ? lightThemePalette : darkThemePalette
    }

    return createTheme(options);

}
